enum FeatureFlags {
  CART_HAMS_CCP_OPEN_QUOTE_MIGRATION = 'cart-hams-ccp-open-quote-migration',
  CART_MAC_FUNCTIONALITY_MIGRATION = 'cart-mac-functionality-migration',
  CART_RENAME_ATLASSIAN_ACCESS_TO_GUARD = 'cart-rename-atlassian-access-to-guard',
}

export default FeatureFlags;
